import DatetimePicker from './components/DatetimePicker'

const install = Vue => {
  Vue.component('v-datetime-picker', DatetimePicker)
}

export default install